module.exports = "<!-- START HEADER-->\r\n<header class=\"header\" app-header></header>\r\n<!-- END HEADER-->\r\n<!-- START SIDEBAR-->\r\n<nav class=\"page-sidebar\" id=\"sidebar\" app-sidebar></nav>\r\n<!-- END SIDEBAR-->\r\n\r\n<!-- START PAGE CONTENT-->\r\n<div class=\"content-wrapper\">\r\n    <router-outlet></router-outlet>\r\n    <footer class=\"page-footer\" app-footer></footer>\r\n</div>\r\n<!-- END PAGE CONTENT-->\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/layouts/layout.component.html
// module id = ../../../../../src/app/layouts/layout.component.html
// module chunks = main